import Vue from 'vue';
import Component from 'vue-class-component';
import { IConfigurationService, IChatModsConfiguration } from '@/app-modules/config';
import { SERVICE_IDENTIFIERS } from '@/app-modules/_ioc/service-identifiers';
import { ILocalisationService } from '@/app-modules/localisation-service';
import { IErrorService } from '@/app-modules/error';

// @ts-ignore
@Component
abstract class TombolaBaseAbstractComponent extends Vue {
  protected created(): any {
    this.localisationService.refreshCurrentLang(this.$lang);
  }

  protected get errorService(): IErrorService {
    return this.$container.get(SERVICE_IDENTIFIERS.IErrorService);
  }

  protected logError(error: Error, userData?: any): void {
    const errorService = this.errorService;
    if (errorService) {
      errorService.logError(error, userData);
    }
  }

  protected logInfo(message: string, userData?: any): void {
    const errorService = this.errorService;
    if (errorService) {
      errorService.logInfo(message, userData);
    }
  }

  protected get localisationService(): ILocalisationService {
    return this.$container.get(SERVICE_IDENTIFIERS.ILocalisationService);
  }

  protected get configService(): IConfigurationService {
    const configServiceResolver = this.getConfigServiceResolver();
    const configService = configServiceResolver();
    return configService;
  }

  protected getConfigServiceResolver(): () => IConfigurationService {
    return (() => this.$container.get(SERVICE_IDENTIFIERS.IConfigurationService) as IConfigurationService).bind(this);
  }

  protected async configuration(): Promise<IChatModsConfiguration> {
    return await this.configService.getConfiguration();
  }

  public SortDateDescending(first: string, second: string): number {
    return Date.parse(second) - Date.parse(first);
  }
}

@Component
// @ts-ignore
export default class TombolaBaseComponent extends TombolaBaseAbstractComponent
{
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/base/base.component.ts